import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { KentRebalancingSchedule } from '@cast/types-kent';

import { apiClient } from '@cast/infrastructure-api';

import { useCurrentOrganizationId } from '@cast/infrastructure-organization';

const KENT_REBALANCING_SCHEDULES_QUERY_KEY = 'kent-rebalancing-schedules';

export const getClusterRebalancingSchedulesQueryKey = (clusterId: string) =>
  [KENT_REBALANCING_SCHEDULES_QUERY_KEY, clusterId] as const;

export const getClusterRebalancingSchedulesQueryOptions = ({
  organizationId,
  clusterId,
}: {
  organizationId: string;
  clusterId: string;
}) =>
  queryOptions({
    queryKey: getClusterRebalancingSchedulesQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.kent.listRebalancingSchedules({
        organizationId,
        clusterId,
      });
      return data.schedules || [];
    },
  });

type GetClusterFeaturesQueryArgs = QueryOptions<KentRebalancingSchedule[]> & {
  clusterId: string;
};

export const useGetClusterRebalancingSchedulesQuery = ({
  clusterId,
  enabled,
}: GetClusterFeaturesQueryArgs) => {
  const currentOrganizationId = useCurrentOrganizationId();

  return useQuery({
    ...getClusterRebalancingSchedulesQueryOptions({
      organizationId: currentOrganizationId,
      clusterId,
    }),
    enabled,
  });
};
